module.exports = __webpack_public_path__ + "img/help-circle.6b0f8d53.svg";